import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";
import { signInWithCode, signInWithEmail } from "../actions/Signin.action";

const signinStore = create((get) => ({
  signinByEmail: async (email) => {
    try {
      const response = await signInWithEmail(email, true);
    } catch (e) {
      console.log("Couldn't send the email");
    }
  },

  signinByCode: async (code, email) => {
    try {
      const response = await signInWithCode({
        code,
        email,
      });
      await AsyncStorage.setItem("token", `${response.data.token}`);
    } catch (e) {
      console.log("Couldn't verify");
      return false;
    }
  },
  resendCode: async (email) => {
    await signinStore.getState().signinByEmail(email);
  },
}));

export default signinStore;
